<template>
  <v-content>
    <br>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="9" md="5" lg="4">
          <v-card class="elevation-12">
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>Gisers Uniformes</v-toolbar-title>
            </v-toolbar>
            <v-row align="center" justify="center">
              <p style="margin-top: 4%;">v{{ $version }}</p>
              <v-col cols="12" sm="12" md="12" align="center" justify="center">
                <v-img src="../assets/logo-giser.png" alt="" width="300" height="100"></v-img>
              </v-col>
            </v-row>

            <v-card-text>

              <v-btn color="primary" @click="login()" style="margin-top: 4%;"
                :disabled="!continuar"
              >{{ continuar ? 'Continuar' : 'Validando...' }}</v-btn>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

  </v-content>
</template>

<script>
import { host, getPublicIP } from '../tools'
import router from '../router';
import swal from 'sweetalert';
import axios from 'axios';
import api from '../conf/ruta-base';
export default {
  name: 'Recovery',
  data: function () {
    return {
      continuar: false,
    }
  },
  mounted(){
    try {
      getPublicIP()
      axios.post(api.api + '/users/validate-code',{
        code: this.$route.query.intention,
        host: host(),
      }).then(()=> {
        swal('', "Se ha enviado su nueva clave a su correo electronico", 'success')
        this.continuar = true
      })
    } catch (error) {
      swal('', "Se ha generado un error al regenerar su nueva clave", 'error')
      router.push('/login')
    }
  },
  methods: {
    login(){
      router.push('login')
    }
  }
}
</script>